import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { Section2Component } from '../section2/section2.component';

@Component({
    selector: 'app-sections360',
    templateUrl: './sections360.component.html',
    styleUrls: ['./sections360.component.scss'],
    providers: [Section2Component]
})
export class Sections360Component implements OnInit {

    constructor(private _Globals: Globals,
        private _Section2Component: Section2Component) { }

  ngOnInit() {
  }

    tabSelect(tabIndex: any) {
        tabIndex = parseInt(tabIndex);
        console.log(tabIndex);

        switch (tabIndex) {
            case 1: {
                this.executeSizeToFit(this._Section2Component, 0);
                break;
            }
        }
    }

    executeSizeToFit(gridApi: any, tabIndex) {
        gridApi.sizeToFit(this._Globals.gridApis[tabIndex]);
    }

    ngOnDestroy() {
        this._Globals.gridApis = [];
    }

}
